import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import { Typography } from "components/controls/widget";
import Loading, { LoadingInfo } from "common/components/controls/Loading";
import Error from "common/components/controls/Error";
import { DisplayLicence, LicenceType } from "common/api/members/licencess";
import * as moment from "moment";

export interface PrispItem {
    rok: number;
    loadingInfo: LoadingInfo;
    prispevky: DisplayLicence[];
}


interface SeznamPrispevkuItemProps {
    item: PrispItem;
}


class SeznamPrispevkuItem extends React.PureComponent<SeznamPrispevkuItemProps & WithStyles<typeof styles>> {

    getPrispName = (p: DisplayLicence) => {
        switch (p.type) {
            case LicenceType.Member:
                return "Základní příspěvek";
            case LicenceType.Amateur:
                return "Soutěžní licence amatérská";
            case LicenceType.Proffesional:
                return "Soutěžní licence profi";
            case LicenceType.Adjudicator:
                return "Porotce";
            case LicenceType.Couch:
                return "Trenér";
            case LicenceType.Official:
                return "Funkcionář";
        }
    }

    render() {
        const { classes, item } = this.props;
        const { loading, hasError, error } = item.loadingInfo;
        return loading
            ? <Loading loading={loading} />
            : hasError
                ? <Error>{error}</Error>
                : <Grid container direction="row" justify="flex-start" spacing={16} className={classes.root} alignItems="center">
                    <Grid item><Typography variant="h6">{item.rok}</Typography></Grid>
                    <Grid item>
                        <Grid container direction="row" justify="flex-start" spacing={8}>
                            {item.prispevky.map(p => <Grid item key={p.type}><Chip variant="outlined" color="primary" label={this.getPrispName(p)} /></Grid>)}
                        </Grid>
                    </Grid>
                </Grid>;
    }
}


const styles = (theme: Theme) => createStyles({
    root: {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
    },
});


export default withStyles(styles)(SeznamPrispevkuItem);
